var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-grid-layout',[_c('template',{slot:"h1"},[_vm._v("Meine Favoriten")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }